// Marketing PR-C — Pre-Set Texts API client.
// Mounted server-side at /api/marketing/preset-texts-v2 (suffix to avoid
// collision with the legacy fixed-5-types endpoints in the MarketingHub).

import { apiGet, apiPost, apiPatch, apiDel } from '../lib/api.js';

const BASE = '/marketing/preset-texts-v2';

export const listPresetTexts = (params = {}) => {
  const q = new URLSearchParams();
  if (params.q) q.set('q', params.q);
  if (params.category) q.set('category', params.category);
  const qs = q.toString();
  return apiGet(`${BASE}${qs ? `?${qs}` : ''}`);
};
export const getPresetText = (id) => apiGet(`${BASE}/${id}`);
export const createPresetText = (body) => apiPost(BASE, body);
export const updatePresetText = (id, body) => apiPatch(`${BASE}/${id}`, body);
export const deletePresetText = (id) => apiDel(`${BASE}/${id}`);
export const sendPresetText = (id, leadId) => apiPost(`${BASE}/${id}/send`, { leadId });
export const previewPresetText = (body, leadId) => apiPost(`${BASE}/preview`, { body, leadId });
export const getVariableCatalog = () => apiGet(`${BASE}/variables/catalog`);
